/**
 * Calculate KPI metrics from sessions data
 * @param {Array} sessions - Array of session objects from the API
 * @param {number} p95_latency - P95 latency value from the API
 * @returns {Object} Calculated KPI metrics
 */
export function calculateSessionKpis(sessions, p95_latency = 0) {
  if (!sessions || sessions.length === 0) {
    return {
      activeSessions: 0,
      medianTurns: 0,
      totalCost: 0,
      totalTokens: 0,
      errorRate: 0,
      p95Latency: 0,
      sessionsWithPromptInjections: 0,
      totalPromptInjections: 0,
      sessionsWithDataExfiltrations: 0,
      totalDataExfiltrations: 0
    };
  }

  const activeSessions = sessions.length;
  const totalTokens = sessions.reduce((sum, s) => sum + (s.total_tokens || 0), 0);
  const totalCost = sessions.reduce((sum, s) => sum + (s.cost || 0), 0);

  const traceCounts = sessions.map(s => s.trace_count || 0).sort((a, b) => a - b);
  const medianIndex = Math.floor(traceCounts.length / 2);
  const medianTurns = traceCounts[medianIndex] || 0;

  const sessionsWithErrors = sessions.filter(s => s.error_rate > 0).length;
  const errorRate = (sessionsWithErrors / activeSessions) * 100;

  const sessionsWithPromptInjections = sessions.filter(s => s.has_prompt_injection).length;
  const totalPromptInjections = sessions.reduce((sum, s) => sum + (s.prompt_injection_count || 0), 0);

  const sessionsWithDataExfiltrations = sessions.filter(s => s.has_data_exfiltration).length;
  const totalDataExfiltrations = sessions.reduce((sum, s) => sum + (s.data_exfiltration_count || 0), 0);

  return {
    activeSessions,
    medianTurns,
    totalCost,
    totalTokens,
    errorRate,
    p95Latency: Math.round(p95_latency),
    sessionsWithPromptInjections,
    totalPromptInjections,
    sessionsWithDataExfiltrations,
    totalDataExfiltrations
  };
}
